import { RouteRecordRaw } from 'vue-router'
import adminMemberRoutes from './admin/member'
import adminBusinessRoutes from './admin/business'
import adminFinanceRoutes from './admin/finance'
import adminContentRoutes from './admin/content'
import adminReportRoutes from './admin/report'
import adminGameRoutes from './admin/game'
import adminCouponRoutes from './admin/coupon'
import adminTicketRoutes from './admin/ticket'
import adminActivityRoutes from './admin/activity'
import adminVipRoutes from './admin/vip'

const adminRoutes: RouteRecordRaw[] = [
  ...adminMemberRoutes,
  ...adminReportRoutes,
  ...adminGameRoutes,
  ...adminBusinessRoutes,
  ...adminCouponRoutes,
  ...adminActivityRoutes,
  ...adminTicketRoutes,
  ...adminVipRoutes,
  ...adminContentRoutes,
  ...adminFinanceRoutes
]

export default adminRoutes
